import React, {FC, useEffect} from 'react'
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs'
import {renderPanelContent} from './components'
import {TabsContent} from '../../../components/UI/Tab'
import 'react-tabs/style/react-tabs.scss'
import {arrayMenuLimpieza} from '../components/Layout/menu'
import {useAuth} from '../../../hooks/useAuth'
import {SetMenu} from '../../../util/functions'
import {useLimpieza} from '../../../hooks/useLimpieza'
const LimpiezaPageWrapper: FC = React.memo(() => {
  const {tabs, deleteTab, changeTab, currentTab, setMenu, setPermissions} = useLimpieza()
  const {applications, handleApplicationId} = useAuth()

  let totalArrays = tabs.length - 1

  const handleDeleteTab = (event: any, id: number) => {
    event.stopPropagation()
    let key = totalArrays === id ? id - 1 : id
    changeTab(key)
    deleteTab(id)
  }

  const handleCurrentKey = (id: number) => {
    changeTab(id)
  }

  useEffect(() => {
    if (applications.length > 0) {
      const filteredApp = applications.filter((app: any) => app.description === 'Hospitality')[0]
      if (filteredApp) {
        SetMenu(filteredApp.aplicacionId, arrayMenuLimpieza, setMenu, setPermissions)
        handleApplicationId(filteredApp.aplicacionId)
      } else {
        //SetMenuMock(arrayMenuLimpieza, setMenu)
        // no existe en api
      }
    }
  }, [applications])
  return (
    <>
      <Tabs
        selectedIndex={currentTab}
        onSelect={(index) => handleCurrentKey(index)}
        className='KHIPU_content_tabs'
      >
        <TabList className={'sdx_tab_panel px-0'}>
          {tabs.map((item, index) => {
            return (
              <Tab key={index} className={'sdx_tab_panel_option'}>
                <TabsContent
                  name={item.title}
                  idIndex={index}
                  idCurrent={Number(currentTab)}
                  closeTab={item.id !== 0}
                  onclickD={(e) => handleDeleteTab(e, index)}
                />
              </Tab>
            )
          })}
        </TabList>
        {tabs.map((item, index) => {
          return <TabPanel key={index}>{renderPanelContent(item.submenu)}</TabPanel>
        })}
      </Tabs>
    </>
  )
})

export default LimpiezaPageWrapper
